import * as c from "../actions/constants";

const initialState = {
    usersWhoCanEditInstance: {}
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case c.USER_CAN_USER_EDIT_INSTANCE:
        {
            let newState = { ...state}; // duplicate because redux wants it FIXME: does he ?

            let {
                usersList,
                canEdit,
                instanceId
            } = action.payload;
            newState.usersWhoCanEditInstance[instanceId] = usersList;
            return newState;
        }
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/canUserEditThisOrganizationReducer.js